<template>
  <span class="rf-icon" aria-hidden="true">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
      <path fill="inherit" stroke="none" d="M8 18.8v-14l11 7z" />
    </svg>
  </span>
</template>
